import { render, staticRenderFns } from "./EmptyTableMsg.vue?vue&type=template&id=0c451668&scoped=true"
import script from "./EmptyTableMsg.vue?vue&type=script&lang=js"
export * from "./EmptyTableMsg.vue?vue&type=script&lang=js"
import style0 from "./EmptyTableMsg.vue?vue&type=style&index=0&id=0c451668&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c451668",
  null
  
)

export default component.exports